<template>
  <div id="Players">
    <div class="players" v-for="(p, index) in players" :key="index">
      <div class="playerName">{{ p.name }}</div>
      <!-- <button class="submit pointer" @click="removePlayer(index)">
        remove
      </button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Players",
  props: {
    players: {
      type: Object,
      default: () => {},
    },
    gamePhase: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {};
  },

  methods: {
    removePlayer(playerId) {
      let isExecuted = confirm(
        "Are you sure you want to remove Player: " + this.players[playerId].name
      );
      if (!isExecuted) return;
      console.log("Remove " + playerId);
      this.$emit("removePlayer", playerId);
    },
  },
  created() {},
};
</script>

<style scoped>
#Players {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.players {
  background: #214a7c;
  min-width: 100px;
  max-width: 150px;
  color: white;
  text-align: center;
  flex: 1 1 30%;
  margin: 5px;
}

.players > button {
  margin: 0px;
}

.playerName {
  margin: 7px;
}

.submit {
  height: 30px;
  border: 2px solid #ffffff;
  background: #214a7c;
  color: #ffffff;
  width: 80%;
  font-size: 16px;
}

.submit:hover {
  border: 3px solid #214a7c;
  background: #ffffff;
  color: #214a7c;
}
</style>
